module.exports = __webpack_public_path__ + "img/UkFlag.389e351c.svg";